import { Outlet } from 'react-router';
import Header from './Header';
import Footer from './Footer';

function Root() {
  return (
    <div style={{position:'relative',minHeight:'100vh'}}>
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}

export default Root;